if (!customElements.get('hh-product-description')) {
  customElements.define('hh-product-description', class extends HTMLElement {
    connectedCallback() {
      if (!this.tables) {
        this.tables = [...this.querySelectorAll('table')].map(table => {
          const hint = document.createElement('p');
          hint.className = 'hh-product-table-hint';
          hint.textContent = this.dataset.scrollHint;
          hint.hidden = true;
          const scroll = document.createElement('div');
          scroll.className = 'hh-product-table-scroll';
          scroll.setAttribute('role', 'region');
          scroll.setAttribute('aria-label', this.dataset.tableLabel);
          table.before(hint, scroll);
          scroll.append(table);
          return {table, scroll, hint};
        });
      }
      const measure = () => this.tables.forEach(({scroll, hint}) => {
        const overflow = scroll.clientWidth > 0 && scroll.scrollWidth > scroll.clientWidth + 1;
        hint.hidden = !overflow;
        scroll.tabIndex = overflow ? 0 : -1;
      });
      this.observer?.disconnect();
      this.observer = new ResizeObserver(measure);
      this.tables.forEach(({table, scroll}) => {
        this.observer.observe(table);
        this.observer.observe(scroll);
      });
      measure();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
